export const ALERT_COLORS = {
  SUCCESS: '#cfffcf',
  ERROR: '#ffece9',
  NEUTRAL: '#ebe7e4',
  WARNING: '#fff2b9',
} as const;
